import axios from '@/axiosInterceptor';

const state = () => ({
  results: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
  },
});

// getters
const getters = {};

// actions
const actions = {
  async getSavedSearches({ commit }, params = {}) {
    try {
      params['q[s]'] = 'id desc';

      let res = await axios.get(
        process.env.API_IDENTITY + '/api/v1/saved_searches',
        {
          params,
        }
      );
      commit('setSavedSearches', res.data);
      commit('setPagination', res.headers);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (status && [401, 403, 404, 422].includes(status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async createSavedSearch(_, payload) {
    const data = { saved_search: payload };
    try {
      let res = await axios.post(
        process.env.API_IDENTITY + '/api/v1/saved_searches',
        data
      );
      // commit('setSavedSearches', res.data)
      // commit('setPagination', res.headers)
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (status && [401, 403, 404, 422].includes(status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
  async deleteSavedSearch({ commit }, id) {
    try {
      let res = await axios.delete(
        process.env.API_IDENTITY + '/api/v1/saved_searches/' + id
      );
      commit('deleteSavedSearch', id);
      return res;
    } catch (e) {
      let status = e.response?.status;
      if (status && [401, 403, 404, 422].includes(status)) {
        return e.response;
      } else {
        throw e;
      }
    }
  },
};

const mutations = {
  setSavedSearches(state, data) {
    state.results = data;
  },
  setPagination(state, headers) {
    console.log(headers.totalitems);
    state.pagination = {
      currentPage: headers.currentpage,
      totalPages: headers.totalpages,
      totalRecords: headers.totalitems,
    };
  },
  deleteSavedSearch(state, id) {
    state.results = state.results.filter(function (savedSearch) {
      return savedSearch.id != id;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
